/**
 * Naziv jednog priloga/izbora iz `prilog[]` izveštaja gostiju. Običan prilog nosi `name`, a izbor paketa stiže kao
 * stavka sa objektom jela (`food` ili `meals`), kao i u kuhinjskom prikazu.
 */
export const prilogName = (item) =>
  (item && ((item.food && item.food.name) || (item.meals && item.meals.name) || item.name)) || "";

/** Prilozi jednog jela/obroka kao tekst: različiti nazivi, razdvojeni zarezom (bez praznih i ponovljenih). */
export const joinPrilog = (items) => {
  const names = [];
  (Array.isArray(items) ? items : []).forEach((item) => {
    const name = prilogName(item);
    if (name && !names.includes(name)) {
      names.push(name);
    }
  });
  return names.join(", ");
};
